// extracted by mini-css-extract-plugin
module.exports = {"titre":"verandas-module--titre--3ofSC","choix":"verandas-module--choix--1mSSr","carte":"verandas-module--carte--Uudd3","contenu":"verandas-module--contenu--1anJK"};